/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestExpectationType } from "./QuoteTestExpectationType";
import {
  QuoteTestExpectationTypeFromJSON,
  QuoteTestExpectationTypeFromJSONTyped,
  QuoteTestExpectationTypeToJSON,
  QuoteTestExpectationTypeToJSONTyped,
} from "./QuoteTestExpectationType";

/**
 *
 * @export
 * @interface QuoteTestExecutionExpectation
 */
export interface QuoteTestExecutionExpectation {
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestExecutionExpectation
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionExpectation
   */
  createdBy?: string;
  /**
   *
   * @type {QuoteTestExpectationType}
   * @memberof QuoteTestExecutionExpectation
   */
  type?: QuoteTestExpectationType;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionExpectation
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionExpectation
   */
  metadata?: string;
}

/**
 * Check if a given object implements the QuoteTestExecutionExpectation interface.
 */
export function instanceOfQuoteTestExecutionExpectation(
  value: object,
): value is QuoteTestExecutionExpectation {
  return true;
}

export function QuoteTestExecutionExpectationFromJSON(
  json: any,
): QuoteTestExecutionExpectation {
  return QuoteTestExecutionExpectationFromJSONTyped(json, false);
}

export function QuoteTestExecutionExpectationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionExpectation {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    type:
      json["type"] == null
        ? undefined
        : QuoteTestExpectationTypeFromJSON(json["type"]),
    description: json["description"] == null ? undefined : json["description"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
  };
}

export function QuoteTestExecutionExpectationToJSON(
  json: any,
): QuoteTestExecutionExpectation {
  return QuoteTestExecutionExpectationToJSONTyped(json, false);
}

export function QuoteTestExecutionExpectationToJSONTyped(
  value?: QuoteTestExecutionExpectation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    type: QuoteTestExpectationTypeToJSON(value["type"]),
    description: value["description"],
    metadata: value["metadata"],
  };
}
